module.exports = __webpack_public_path__ + "img/20230802084439650pjk.52b9aba0.png";